<template>
  <view>
    <view>slot + wx:model来开展使用能力</view>
    <view class="bg-white">
      <cube-collapse
        switch-text="{{ [] }}"
        wx:model="{{ collapsed }}"
        wx:model-prop="collapsed"
      >
        <view>
          <view>内容，第一行</view>
          <view>内容，第二行</view>
          <view>内容，第三行</view>
        </view>
        <view slot="top-switch">点我使用组件的展开、收起</view>
      </cube-collapse>

      <view>-------</view>
      <view bindtap="collapsedHandler">点我通过wx:model进行展开、收起</view>
      <view>collapsed: {{ collapsed }}</view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  data: {
    collapsed: true
  },
  methods: {
    collapsedHandler() {
      this.collapsed = !this.collapsed
    }
  }
})
</script>

<style lang="stylus" scoped>
.bg-white
  margin-top: 6px
  background-color: #fff
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-collapse": "@mpxjs/mpx-cube-ui/src/components/collapse/index"
    }
  }
</script>
